module.exports = __webpack_public_path__ + "static/manument-8095901c3b42933327f479c6baa9bbf8.mp4";